import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import Styles from './RoomSensor.module.css';

const RoomSensor = (props) => (
  <Table>
      <TableHead>
        <TableRow>
          <TableCell>Temperature (°C)</TableCell>
          <TableCell numeric>Pressure (hPa)</TableCell>
          <TableCell numeric>Hygrometry (%)</TableCell>
          <TableCell numeric>Timestamp</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {
          props.rows.map(row => {
            return (
              <TableRow className={ row.temperature > 25 ? Styles.hot : (row.temperature < 21 ? Styles.cold : '') } key={row.id}>
                <TableCell component="th" scope="row">
                  {row.temperature}
                </TableCell>
                <TableCell numeric>{row.pressure}</TableCell>
                <TableCell numeric>{row.hygrometry}</TableCell>
                <TableCell numeric>{moment.unix(row.timestamp).format("h:mm:ss a, dddd, MMMM Do YYYY")}</TableCell>
              </TableRow>
            );
          })
        }
      </TableBody>
    </Table>
);

export default RoomSensor;
